import { render } from "./FooterCN.vue?vue&type=template&id=ffad1736&scoped=true"
import script from "./FooterCN.vue?vue&type=script&lang=js"
export * from "./FooterCN.vue?vue&type=script&lang=js"

import "./FooterCN.vue?vue&type=style&index=0&id=ffad1736&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffad1736"]])

export default __exports__